export default "__VITE_ASSET__a3523e5c__"